import { memo, useCallback } from "react";
import { batch, useSelector, useDispatch } from "react-redux";

import { login as onLogin, vdsmLogin as onVdsmLogin } from "store/login/actions";

import LoginForm from "pages/common/LoginForm";

import { clientRoute } from "utils/constants";
import { isInIframe } from "utils/dom";
import { isAuthenticated, isQrCode, isStatusExpired } from "utils/user";

import { VLMLoginProps } from "./types";

const VLMLogin = memo(({ onOpen }: VLMLoginProps) => {
    const dispatch = useDispatch();

    // @ts-ignore
    const user = useSelector((state) => state.vdsmUser);

    // @ts-ignore
    const login = useSelector((state) => state.login);

    const pathParts = window.location.pathname.split("/")[1];

    // Redirect top window to login page
    if (window.top && !isAuthenticated(user) && isInIframe()) {
        window.top.location.replace(window.location.href);
    }

    // Open Reset Password view
    if (pathParts === clientRoute.resetPassword) {
        onOpen({
            name: "Reset Password",
            component: "ResetPassword",
            showHeader: false,
            showTabs: false,
        });
    }
    // Open Authenticator set up view
    else if (isQrCode(user)) {
        onOpen({
            name: "QR Code",
            component: "QrCode",
            showHeader: false,
            showTabs: false,
        });
    }
    // Open Change Password view
    else if (isStatusExpired(user)) {
        onOpen({
            name: "Change Password",
            component: "ChangePassword",
            showHeader: false,
            showTabs: false,
        });
    }

    const handleSubmit = useCallback(
        (values) => {
            batch(() => {
                dispatch(onLogin(values));
                dispatch(onVdsmLogin(values));
            });
        },
        [dispatch]
    );

    const handleForgotPassword = useCallback(() => {
        onOpen({
            name: "Forgot Password",
            component: "ForgotPassword",
            showHeader: false,
            showTabs: false,
        });
    }, [onOpen]);

    return (
        <LoginForm
            isLoading={login.isLoading}
            errorMessage={login.errorMessage}
            onSubmit={handleSubmit}
            onForgotPassword={handleForgotPassword}
        />
    );
});

export default VLMLogin;
